import { FC } from 'react';
import { notificationNavigation } from '../../constants/notifications';
import { SCREENS } from 'src/constants/screens';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from 'src/view/containers/Headers/Headers';
import ScreenTabsNavigation from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';

const NotificationsSettingNavigation: FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column">
      <Headers>
        <HeaderBack title="notifications" path={SCREENS.SETTINGS()} isBeta />
      </Headers>

      <ScreenTabsNavigation options={notificationNavigation()} showSoloOption className="mt-6 mb-4" />
    </div>
  );
};

export default NotificationsSettingNavigation;
